import { render, staticRenderFns } from "./MergeGroupDetailModal.vue?vue&type=template&id=e6b91d2a&scoped=true"
import script from "./MergeGroupDetailModal.vue?vue&type=script&lang=js"
export * from "./MergeGroupDetailModal.vue?vue&type=script&lang=js"
import style0 from "./MergeGroupDetailModal.vue?vue&type=style&index=0&id=e6b91d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b91d2a",
  null
  
)

export default component.exports